import { msiRequest } from "../../../index";
import { ResultType } from "../../../types";
import qs from "qs";
//接口url枚举
enum StatisticalEnumApi {
  WARETOOL_PAGE = "/WareTool/page", //分页查询工量具基础表
  WARETOOL_ADD = "/WareTool/add", //增加工量具基础表
  WARETOOL_EDIT = "/WareTool/edit", //更新
  WARETOOL_DELETE = "/WareTool/delete", //删除
  WARETOOL_DETAIL = "/WareTool/detail", //详情,
  FILEDOWNLOAD = '/sysFileInfo/download',//文件下载
}
//工量具 --- 列表
export function getWareToolPage(data: any = {}) {
  return msiRequest.get<ResultType<any>>({
    url: `${StatisticalEnumApi.WARETOOL_PAGE}?${qs.stringify(data)}`,
    data
  });
}

//工量具 -- 添加
export function addWareTool(data: any = {}) {
  return msiRequest.post<ResultType<any>>({
    url: StatisticalEnumApi.WARETOOL_ADD,
    data
  });
}

//工量具 -- 编辑
export function editWareTool(data: any = {}) {
  return msiRequest.post<ResultType<any>>({
    url: StatisticalEnumApi.WARETOOL_EDIT,
    data
  });
}

//工量具 -- 删除
export function deleteWareTool(data: { orderNo: string }) {
  return msiRequest.post<ResultType<any>>({
    url: StatisticalEnumApi.WARETOOL_DELETE,
    data
  });
}

//工量具 -- 详情
export function detailWareTool(data: { orderNo: string }) {
  return msiRequest.post<ResultType<any>>({
    url: `StatisticalEnumApi.WARETOOL_DETAIL?Id=${qs.stringify(data)}`,
    data
  });
}

export function downLoadFunction(data: any) {
  return msiRequest.get({
    url: `${StatisticalEnumApi.FILEDOWNLOAD}?${qs.stringify(data)}`,
    responseType: 'blob',
    data
  })
}